import { InternalApplicationStatuses } from "../MPP-Common-SPA/common/constants/statuses";
import { useGetVoucherQuery, useGetBenefitsQuery } from "../Store/api/apiSlice";

export const useAdditionalDetails = (
  internalStatus: number,
  applicationId: string,
) => {
  const isVoucherIssued =
    internalStatus === InternalApplicationStatuses.VoucherIssued;
  const { data: voucher } = useGetVoucherQuery(applicationId, {
    skip: !isVoucherIssued || !applicationId,
  });

  const isBenefitStatus =
    internalStatus === InternalApplicationStatuses.PaymentSent ||
    internalStatus === InternalApplicationStatuses.PaymentComplete;
  const { data: benefits } = useGetBenefitsQuery(applicationId, {
    skip: !isBenefitStatus || !applicationId,
  });

  return { voucher, benefits };
};
